import React from 'react';

const RedirectPage = () => {
  const handleRedirect = () => {
    window.location.href = 'https://shinebeam.vn/vn';
  };

  return (
    <div className="flex flex-col items-center justify-center h-screen bg-gradient-to-b from-pink-50 to-white">
      <h2 className="text-xl font-semibold text-gray-700 mb-6">
        Nhấn nút bên dưới để tiếp tục
      </h2>
      <button
        onClick={handleRedirect}
        className="px-8 py-3 rounded-2xl bg-gradient-to-r from-pink-300 via-pink-400 to-pink-500 
                   text-white font-semibold text-lg shadow-lg hover:scale-105 transform 
                   transition-all duration-300 ease-in-out"
      >
        ✨ Tiếp tục ✨
      </button>
    </div>
  );
};

export default RedirectPage;
